var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 526,
    height: 538,
    viewBox: "0 0 526 538",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M335.719 242.92V190.548",
    stroke: "white",
    strokeWidth: 2.7226,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.417 93.1243L50.1416 71.0654",
    stroke: "white",
    strokeWidth: 0.54452,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3672 109.913L45.8029 106.24",
    stroke: "white",
    strokeWidth: 0.54452,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212.576 312.299L336.727 241.581",
    stroke: "white",
    strokeWidth: 2.7226,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M194.127 162.62V110.248",
    stroke: "white",
    strokeWidth: 2.7226,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5098 113.539L11.5098 5.21387",
    stroke: "white",
    strokeWidth: 1.15855,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.984 232L195.14 161.282",
    stroke: "white",
    strokeWidth: 2.7226,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.417 77.9709L50.1416 55.9121",
    stroke: "white",
    strokeWidth: 0.54452,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.417 63.1536L50.1416 41.0947",
    stroke: "white",
    strokeWidth: 0.54452,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.417 48.2825L50.1416 26.2236",
    stroke: "white",
    strokeWidth: 0.54452,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6091 89.5098L66.8013 118.717",
    stroke: "white",
    strokeWidth: 0.54452,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2463 65.1641L62.7757 82.0963",
    stroke: "white",
    strokeWidth: 0.54452,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66443 49.2891L19.0464 59.0151",
    stroke: "white",
    strokeWidth: 0.54452,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M328.125 398.704L496.793 498.832",
    stroke: "white",
    strokeWidth: 2.7226,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M318.758 403.391L487.426 503.519",
    stroke: "white",
    strokeWidth: 2.7226,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4059 118.717C8.5617 118.717 6.25039 116.429 6.23301 113.596C6.21563 110.763 8.50957 108.458 11.3538 108.44C14.2676 108.429 16.6252 110.752 16.5963 113.608C16.5615 116.44 14.2502 118.717 11.4059 118.717Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M336.721 194.684C333.877 194.684 331.566 192.395 331.549 189.563C331.531 186.73 333.825 184.425 336.669 184.407C339.583 184.396 341.941 186.719 341.912 189.574C341.877 192.407 339.566 194.684 336.721 194.684Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M195.129 114.39C192.285 114.39 189.974 112.102 189.956 109.269C189.939 106.436 192.233 104.131 195.077 104.113C197.991 104.102 200.349 106.425 200.32 109.28C200.285 112.113 197.974 114.39 195.129 114.39Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5038 6.95131C9.59608 6.95131 8.04578 5.40354 8.03412 3.48743C8.02247 1.57132 9.56112 0.0117845 11.4689 2.91882e-05C13.4233 -0.00780767 15.0046 1.56347 14.9852 3.49526C14.9619 5.41137 13.4116 6.95131 11.5038 6.95131Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1362 27.317C48.9081 27.317 47.906 26.3265 47.9002 25.0984C47.8944 23.8761 48.8849 22.874 50.113 22.8682C51.3758 22.8624 52.3954 23.8703 52.378 25.1042C52.3664 26.3323 51.3642 27.317 50.1304 27.317H50.1362Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1362 43.277C48.9081 43.277 47.906 42.2864 47.9002 41.0584C47.8944 39.8361 48.8849 38.8339 50.113 38.8281C51.3758 38.8224 52.3954 39.8303 52.378 41.0642C52.3664 42.2922 51.3642 43.277 50.1304 43.277H50.1362Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1362 58.1364C48.9081 58.1364 47.906 57.1458 47.9002 55.9177C47.8944 54.6955 48.8849 53.6933 50.113 53.6875C51.3758 53.6817 52.3954 54.6897 52.378 55.9235C52.3664 57.1516 51.3642 58.1364 50.1304 58.1364H50.1362Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1362 73.2897C48.9081 73.2897 47.906 72.2991 47.9002 71.0711C47.8944 69.8488 48.8849 68.8466 50.113 68.8408C51.3758 68.8351 52.3954 69.843 52.378 71.0769C52.3664 72.3049 51.3642 73.2897 50.1304 73.2897H50.1362Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6862 120.935C65.4582 120.935 64.456 119.945 64.4502 118.717C64.4444 117.494 65.435 116.492 66.6631 116.486C67.9259 116.481 68.9454 117.489 68.928 118.722C68.9164 119.95 67.9143 120.935 66.6804 120.935H66.6862Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3498 84.319C62.1217 84.319 61.1196 83.3284 61.1138 82.1004C61.108 80.8781 62.0986 79.8759 63.3266 79.8701C64.5894 79.8643 65.609 80.8723 65.5916 82.1061C65.58 83.3342 64.5779 84.319 63.344 84.319H63.3498Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23603 51.5143C1.00797 51.5143 0.00581804 50.5237 2.52778e-05 49.2957C-0.00576748 48.0734 0.984795 47.0712 2.21286 47.0655C3.47568 47.0597 4.49521 48.0676 4.47783 49.3015C4.46625 50.5295 3.4641 51.5143 2.23024 51.5143H2.23603Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3616 112.131C38.1336 112.131 37.1314 111.141 37.1256 109.913C37.1198 108.691 38.1104 107.688 39.3385 107.683C40.6013 107.677 41.6208 108.685 41.6034 109.919C41.5919 111.147 40.5897 112.131 39.3559 112.131H39.3616Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M170.724 427.379C167.88 427.379 165.568 425.091 165.551 422.258C165.534 419.425 167.827 417.12 170.672 417.103C173.585 417.091 175.943 419.414 175.914 422.27C175.879 425.102 173.568 427.379 170.724 427.379Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M170.735 423.074V492.952L343.835 388.735L11.417 196.253V115.056",
    stroke: "white",
    strokeWidth: 2.7226,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M475.116 525.485C454.089 525.485 436.983 508.24 436.861 486.922C436.739 465.605 453.712 448.227 474.751 448.117C496.318 448.007 513.766 465.512 513.522 487.004C513.279 508.35 496.173 525.491 475.116 525.485Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 7.71596,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M434.167 493.723H422.425V478.471H434.167",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M440.104 462.998L431.89 454.61L442.786 443.939L451 452.327",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M466.444 446.436V434.694H481.702V446.436",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M514.258 493.723H526V478.471H514.258",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M508.32 462.998L516.534 454.61L505.638 443.939L497.424 452.327",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M434.167 478.73H422.425V493.983H434.167",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M440.104 509.457L431.89 517.851L442.786 528.521L451 520.127",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M466.444 526.023V537.765H481.702V526.023",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M514.258 478.73H526V493.983H514.258",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M508.32 509.457L516.534 517.851L505.638 528.521L497.424 520.127",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M475.179 515.602C491.089 515.602 503.987 502.705 503.987 486.795C503.987 470.885 491.089 457.987 475.179 457.987C459.269 457.987 446.372 470.885 446.372 486.795C446.372 502.705 459.269 515.602 475.179 515.602Z",
    fill: "#716558",
    stroke: "white",
    strokeWidth: 0.886293,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopSm);
export default __webpack_public_path__ + "static/media/desktop-sm.8e08bc9784fa5a9196b0ad46e5507b69.svg";
export { ForwardRef as ReactComponent };